export default __webpack_public_path__ + "static/media/BubshurMap.7a35de5a.jpg";